import { render, staticRenderFns } from "./StockTrend.vue?vue&type=template&id=3ba5ecfa&scoped=true"
import script from "./StockTrend.vue?vue&type=script&lang=js"
export * from "./StockTrend.vue?vue&type=script&lang=js"
import style0 from "./StockTrend.vue?vue&type=style&index=0&id=3ba5ecfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba5ecfa",
  null
  
)

export default component.exports